import { SVGProps } from "react"

const File = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6.25 2.5C5.0095 2.5 4 3.5095 4 4.75V20.25C4 21.4905 5.0095 22.5 6.25 22.5H17.75C18.9905 22.5 20 21.4905 20 20.25V10.5H14.25C13.0095 10.5 12 9.4905 12 8.25V2.5H6.25ZM13.5 2.93945V8.25C13.5 8.6635 13.8365 9 14.25 9H19.5605L13.5 2.93945ZM8.75 13H15.25C15.664 13 16 13.336 16 13.75C16 14.164 15.664 14.5 15.25 14.5H8.75C8.336 14.5 8 14.164 8 13.75C8 13.336 8.336 13 8.75 13ZM8.74512 16.5H13.2432C13.6572 16.5 13.9932 16.8355 13.9932 17.25C13.9937 17.6295 13.7117 17.9437 13.3457 17.9932L13.2441 18H8.74609C8.33209 18 7.99609 17.664 7.99609 17.25C7.99609 16.8705 8.27755 16.5563 8.64355 16.5068L8.74512 16.5Z" fill="#9CA3AF" />
  </svg>

)

export default File
